import * as React from 'react'

import logo from '~/assets/images/logo.svg'

import Text from '~/components/atoms/Text'

const App = () => (
  <div>
    <img src={logo} alt="logo" />
    <Text>ぶりますのーと</Text>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.tsx